import * as React from 'react';
import * as RadixAccordion from '@radix-ui/react-accordion';

// Tailwind styled wrappers for Radix Accordion primitives

export const Accordion = ({ className = '', ...props }) => (
	<RadixAccordion.Root
		className={`w-full rounded-xl bg-[#0B0D10] shadow-2xl ring-1 ring-black/5 dark:ring-white/10 ${className}`}
		{...props}
	/>
);

export const AccordionItem = React.forwardRef(({ className = '', ...props }, ref) => (
	<RadixAccordion.Item
		ref={ref}
		className={`border-b border-gray-200 dark:border-gray-700 ${className}`}
		{...props}
	/>
));
AccordionItem.displayName = 'AccordionItem';

export const AccordionTrigger = React.forwardRef(({ className = '', children, rightContent, ...props }, ref) => (
	<RadixAccordion.Header className="flex">
		<RadixAccordion.Trigger
			ref={ref}
			className={`flex flex-1 items-center justify-between px-6 py-4 text-left text-gray-900 dark:text-gray-100 hover:no-underline focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
			{...props}
		>
			<span>{children}</span>
			<div className="flex items-center gap-2">
				{rightContent && <div onClick={(e) => e.stopPropagation()}>{rightContent}</div>}
				<ChevronIcon className="ml-2 h-4 w-4 shrink-0 transition-transform data-[state=open]:rotate-180" />
			</div>
		</RadixAccordion.Trigger>
	</RadixAccordion.Header>
));
AccordionTrigger.displayName = 'AccordionTrigger';

export const AccordionContent = React.forwardRef(({ className = '', children, ...props }, ref) => (
	<RadixAccordion.Content
		ref={ref}
		className={`overflow-hidden text-sm text-gray-700 dark:text-gray-300 data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down ${className}`}
		{...props}
	>
		<div className="px-6 pb-6 pt-0">
			{children}
		</div>
	</RadixAccordion.Content>
));
AccordionContent.displayName = 'AccordionContent';

const ChevronIcon = ({ className = '' }) => (
	<svg
		className={className}
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<polyline points="6 9 12 15 18 9" />
	</svg>
);

export default Accordion;


